import { AddNewLicenses } from "@/components/settings/AddNewLicenses";
import { getCurrentContract } from "@/utils/organization-helpers";
import { createFileRoute, linkOptions, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_dashboard/settings/_admin/users/_users/add-users",
)({
  component: RouteComponent,
  beforeLoad: (ctx) => {
    // Redirect if there is a pending license addition. This can happen if the user navigates to this page directly
    const contract = getCurrentContract(ctx.context.user!.organization);
    if (!contract || !contract.pendingLicenseAddition) return;
    throw redirect({
      to: "/settings/users",
      replace: true,
    });
  },
});

function RouteComponent() {
  const context = Route.useRouteContext();

  return (
    <div className="mt-7 flex h-full flex-col px-14 pb-12">
      <AddNewLicenses
        backLinkOptions={linkOptions({
          from: Route.fullPath,
          to: "/settings/users",
        })}
        context={context as Required<typeof context>}
      />
    </div>
  );
}
